import { Component, Input, Output, EventEmitter } from "@angular/core";
import { AutoMapperService } from "../../../services/Common/auto-mapper.service";
import { AlertService } from "../../../services";
import { Subscription } from "rxjs/Subscription";
import { DashboardComponent } from "../dashboard-component";
import { HttpClient } from "@angular/common/http";
import { Provinces } from '../../provinces/provinces';
import { LocationGroup } from '../../location-group/location-group';

@Component({
    template: require('./dashboard-table.html'),
    selector: 'dashboard-table',
    styles: [require('./dashboard-table.css')]
})

export class DashboardTableComponent implements DashboardComponent {

    private tableData: Array<any> = null;
    public subscription: Subscription = null;
    @Input() public header: string = '';
    @Input() public subHeader: string = '';
    @Input() public url: string;
    @Output() refreshed = new EventEmitter();

    constructor(
        private http: HttpClient,
        private autoMapperService: AutoMapperService,
        private alertService: AlertService
    ) {
    }

    public update(): void {
        let self: DashboardTableComponent = this;
        this.subscription = this.http.get<any>(this.url)
            .subscribe(result => {
                self.tableData = result;
                self.refreshed.next();
            }, error => self.refreshed.next());
    }

    public updateDashboard(provinces: any, locationGroup:any): void {
        let self: DashboardTableComponent = this;
   
        this.subscription = this.http.post<any>(this.url,{
            provinces: provinces,
            locationGroup: locationGroup
        }).subscribe(result => {
                self.tableData = result;
                self.refreshed.next();
            }, error => self.refreshed.next());
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/dashboard-table/dashboard-table.component.ts